// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
    width: 50px;
    aspect-ratio: 1;
    display: grid;
    border: 4px solid #0000;
    border-radius: 50%;
    border-right-color: #185ABD;
    animation: l15 1s infinite linear;
      
  }

  .loader-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh; /* or any other height you want */
  }

  .loader::before,
  .loader::after {    
    content: "";
    grid-area: 1/1;
    margin: 2px;
    border: inherit;
    border-radius: 50%;
    animation: l15 2s infinite;
  }
  .loader::after {
    margin: 8px;
    animation-duration: 3s;
  }
  @keyframes l15{ 
    100%{transform: rotate(1turn)}
  }`, "",{"version":3,"sources":["webpack://./src/assets/styles/loader.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;IAC3B,iCAAiC;;EAEnC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY,EAAE,iCAAiC;EACjD;;EAEA;;IAEE,WAAW;IACX,cAAc;IACd,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,KAAK,wBAAwB;EAC/B","sourcesContent":[".loader {\n    width: 50px;\n    aspect-ratio: 1;\n    display: grid;\n    border: 4px solid #0000;\n    border-radius: 50%;\n    border-right-color: #185ABD;\n    animation: l15 1s infinite linear;\n      \n  }\n\n  .loader-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 50vh; /* or any other height you want */\n  }\n\n  .loader::before,\n  .loader::after {    \n    content: \"\";\n    grid-area: 1/1;\n    margin: 2px;\n    border: inherit;\n    border-radius: 50%;\n    animation: l15 2s infinite;\n  }\n  .loader::after {\n    margin: 8px;\n    animation-duration: 3s;\n  }\n  @keyframes l15{ \n    100%{transform: rotate(1turn)}\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
